import { useHistory } from 'react-router'
import { useSelector } from 'react-redux'

/**
 * Custom hook for profile navigation functionality
 * @returns {Object} - Navigation utilities
 */
export const useProfileNavigation = () => {
  const history = useHistory()
  const meId = useSelector((s) => s.user?.user?.id)

  /**
   * Navigate to user profile
   * @param {Object} userData - User data object
   * @param {boolean} appearAsDietaSocial - Whether user appears as Dieta Social
   * @returns {boolean} - Whether navigation was successful
   */
  const goToProfile = (userData, appearAsDietaSocial = false) => {
    // If appears as Dieta Social, navigate to the created_by user's profile
    if (appearAsDietaSocial) {
      const profileId = userData?.id;
      if (profileId) {
        history.push(`/u/${profileId}`);
        return true;
      }
      return false;
    }

    // Robustly pick the id the profile page expects
    const profileId =
      userData?.id ??
      userData?.user_id ??
      userData?.master_club_subscriber_id ??
      userData?.created_by_id ??
      null

    if (!profileId) return false

    if (profileId === meId) {
      history.push('/me')
    } else {
      history.push(`/u/${profileId}`)
    }
    return true
  }

  /**
   * Check if profile can be opened
   * @param {Object} userData - User data object
   * @param {boolean} appearAsDietaSocial - Whether user appears as Dieta Social
   * @returns {boolean} - Whether profile can be opened
   */
  const canOpenProfile = (userData, appearAsDietaSocial = false) => {
    // Dieta Social profiles can be opened
    if (appearAsDietaSocial) {
      return !!userData?.id;
    }

    const profileId =
      userData?.id ??
      userData?.user_id ??
      userData?.master_club_subscriber_id ??
      userData?.created_by_id ??
      null

    return !!profileId
  }

  return {
    goToProfile,
    canOpenProfile,
    meId
  }
}
